import clsx from "clsx";

export default function Chevron({ className }: { className?: string }) {
  const defaultClasses = "rounded-full bg-theme-primary fill-white";
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(defaultClasses, className)}
    >
      <path d="M20 16.0657C20 16.1796 19.9542 16.2804 19.8625 16.368L13.457 22.4914C13.3654 22.579 13.26 22.6228 13.1409 22.6228C13.0218 22.6228 12.9164 22.579 12.8247 22.4914L12.1375 21.8343C12.0458 21.7467 12 21.646 12 21.5321C12 21.4182 12.0458 21.3175 12.1375 21.2299L17.5395 16.0657L12.1375 10.9016C12.0458 10.814 12 10.7133 12 10.5994C12 10.4855 12.0458 10.3847 12.1375 10.2971L12.8247 9.64013C12.9164 9.55253 13.0218 9.50873 13.1409 9.50873C13.26 9.50873 13.3654 9.55253 13.457 9.64013L19.8625 15.7635C19.9542 15.8511 20 15.9519 20 16.0657Z" />
    </svg>
  );
}
